export const UPDATE_CAN_ADDRESS_BUY_COINS = 'UPDATE_CAN_ADDRESS_BUY_COINS';

function addressCanBuyCoinsReducer (state = {}, action) {
  switch (action.type) {
    case UPDATE_CAN_ADDRESS_BUY_COINS:
      let newState = {...state};
      newState[action.payload.address] = {
        address: action.payload.address,
        state: action.payload.state
      };

      return newState;
    default:
      return state;
  }
}

export default addressCanBuyCoinsReducer;


// WEBPACK FOOTER //
// ./src/storage/AddressCanBuyCoinsReducer.js